import api from './api';

export interface PRItem {
  id?: number;
  pr_id?: number;
  item_no?: number;
  description: string;
  model_size: string;
  qty: number;
  unit: string;
  remark: string;
  request_qty?: number;
  issued_qty?: number;
  balance_qty?: number;
}

export interface PurchaseRequisition {
  id: number;
  pr_date: string;
  pr_no: string;
  item_no?: string;
  pr_type?: string;
  attention?: string;
  description?: string;
  machine?: string;
  model_size?: string;
  remark?: string;
  status: string;
  delivery_method?: string;
  supplier?: string;
  unit?: string;
  qty?: number;
  sap_code?: string;
  sap_pr?: string;
  quotation_ok_date?: string;
  sap_po?: string;
  grn?: string;
  received_date?: string;
  location?: string;
  request_qty?: number;
  issued_qty?: number;
  balance_qty?: number;
  created_at?: string;
  updated_at?: string;
  created_by?: number;
  updated_by?: number;
  created_by_name?: string;
  updated_by_name?: string;
  items?: PRItem[];
}

export interface PRFilters {
  status?: string;
  pr_no?: string;
  supplier?: string;
  start_date?: string;
  end_date?: string;
  search?: string;
}

export interface PRStats {
  summary: {
    total_prs: number;
    pending_count: number;
    approved_count: number;
    po_created_count: number;
    received_count: number;
    pending_delivery_count: number;
  };
  recentPRs: PurchaseRequisition[];
  pendingDeliveries: PurchaseRequisition[];
}

const purchaseRequisitionService = {
  async getAll(filters?: PRFilters) {
    const params = new URLSearchParams();
    if (filters) {
      Object.entries(filters).forEach(([key, value]) => {
        if (value) params.append(key, value.toString());
      });
    }
    const response = await api.get(`/purchase-requisitions?${params}`);
    return response.data;
  },

  async getById(id: number) {
    const response = await api.get(`/purchase-requisitions/${id}`);
    return response.data;
  },

  async create(data: Partial<PurchaseRequisition>) {
    const response = await api.post('/purchase-requisitions', data);
    return response.data;
  },

  async update(id: number, data: Partial<PurchaseRequisition>) {
    const response = await api.put(`/purchase-requisitions/${id}`, data);
    return response.data;
  },

  async delete(id: number) {
    const response = await api.delete(`/purchase-requisitions/${id}`);
    return response.data;
  },

  async getStats() {
    const response = await api.get('/purchase-requisitions/stats');
    return response.data.stats as PRStats;
  },

  async updateStatus(id: number, status: string) {
    const response = await api.patch(`/purchase-requisitions/${id}/status`, { status });
    return response.data;
  },

  async updateIssuedQty(id: number, issued_qty: number) {
    const response = await api.patch(`/purchase-requisitions/${id}/issued-qty`, { issued_qty });
    return response.data;
  },

  async bulkCreate(data: Partial<PurchaseRequisition>[]) {
    const response = await api.post('/purchase-requisitions/bulk', { data });
    return response.data;
  },
};

export default purchaseRequisitionService;
